import React from 'react';

import { keyedList } from 'utils';

export function formatNumber(num, decimal, separator) {
  if (separator === undefined) {
    return num.toFixed(decimal || 0);
  }
  const parts = num.toFixed(decimal || 0).split(".");
  if (parseFloat(num) >= separator) {
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return parts.join(".");
}

export function formatDamage(val) {
  if (val > 1e+13) {
    return formatNumber(val / 1e+12, 3, 10000) + " T";
  } else if (val > 1e+10) {
    return formatNumber(val / 1e+9, 3, 10000) + " B";
  } else if (val > 1e+7) {
    return formatNumber(val / 1e+6, 3, 10000) + " M";
  } else {
    return formatNumber(val, 0, 10000);
  }
}

/**
 * Replaces {0} tags in string with provided arguments
 * 
 * @param {string} str format string
 * @param {...string|function} args substitutions or callback function
 * @returns {string} formatted string
 */
export function format(str, ...args) {
  const getter = (typeof args[0] === "function" ? args[0] : ((idx, m) => idx in args ? args[idx] : m));
  return str.replace(/{(\d+)}/g, (m, idx) => getter(parseInt(idx), m));
}

/**
 * Replaces {0} tags in string with provided arguments, returns results as an array
 * 
 * @param {string} str format string
 * @param {...string|function} args substitutions or callback function
 * @returns {any[]} formatted string pieces
 */
export function formatReact(str, ...args) {
  const getter = (typeof args[0] === "function" ? args[0] : (idx => args[idx]));
  return keyedList(str.split(/({\d+})/).map(piece => {
    const m = piece.match(/^{(\d+)}$/);
    return m ? getter(parseInt(m[1])) : piece;
  }));
}

export function _R(strings, ...args) {
  let src = strings;
  if (Array.isArray(strings)) {
    src = strings.map((str, index) => (index ? `{${index - 1}}` : "") + str.replace(/[{}]/g, "\\$&")).join("");
  }
  return formatReact(src, ...args);
}

export function formatDescription(text) {
  const colors = {
    magic: "blue",
    rare: "yellow",
    epic: "purple",
    legendary: "orange",
  };
  return text.split(/({c_\w+}.*?{\/c}|\n)/).map((piece, idx) => {
    const m = piece.match(/^{c_(\w+)}(.*){\/c}$/);
    if (m) {
      return <span key={idx} className={`d3-color-${colors[m[1]] || m[1]}`}>{m[2]}</span>;
    } else if (piece === "\n") {
      return <br key={idx}/>;
    } else {
      return piece;
    }
  });
}

export function replaceReact(text, regex, func, textFunc) {
  const result = [];
  function add(element) {
    if (React.isValidElement(element)) {
      result.push(React.cloneElement(element, {key: result.length}));
    } else if (element) {
      result.push(element);
    }
  }
  textFunc = textFunc || (text => text);
  let prev = 0, match;
  while ((match = regex.exec(text))) {
    if (match.index > prev) {
      result.push(textFunc(text.substring(prev, match.index)));
    }
    const element = func(...match, match.index, match.string);
    if (Array.isArray(element)) {
      for (const e of element) {
        add(e);
      }
    } else {
      add(element);
    }
    prev = match.index + match[0].length;
  }
  if (prev < text.length) {
    result.push(textFunc(text.substring(prev)));
  }
  return result;
}
